import { OnboardingStepKeyEnum } from "../../../components/Onboarding";
import useIntegrationStatus from "../../../hooks/useIntegrationStatus";
import { Guider, GuiderStepConfig } from "../../../shared/molecules/Guider/Guider";
import { useMemo } from "react";

export function InvitationGuide({
  handleManageInvitesClick,
}: {
  handleManageInvitesClick: () => void;
}) {
  const { isIntegrationActive } = useIntegrationStatus();
  const azureActive = isIntegrationActive("azure");
  const jiraActive = isIntegrationActive("jira");

  // Define steps
  const steps: GuiderStepConfig[] = useMemo(
    () => [
      {
        key: "about_workitem",
        divId: '[data-onboarding-id="resource-manage-btn"]',
        message: "Here you can manage all of the available resources",
        placement: "bottom",
        onNext: handleManageInvitesClick,
      },

      ...(azureActive || jiraActive
        ? [
            {
              key: "about_workitem",
              divId: '[data-onboarding-id="resource-team-people-btn"]',
              message:
                azureActive && jiraActive
                  ? `Here you can import new users and teams from Azure and Jira`
                  : azureActive
                    ? `Here you can import new users and teams from Azure`
                    : `Here you can import new users from Jira`,
              placement: "bottom" as const,
            },
          ]
        : []),

      {
        key: "about_workitem",
        divId: '[data-onboarding-id="resource-invite-btn"]',
        message: "Here you can invite new users to your organization",
        placement: "bottom",
      },
    ],
    [azureActive, jiraActive],
  );

  return (
    <Guider 
      onboardingKey={OnboardingStepKeyEnum.InvitePeople} 
      steps={steps}
      onCompleteSettingsKey="invite_people" 
    />
  );
}
